export const apiBasePath = "SVELTE_APP_API_URL"
export const patientRole = "patient"
export const doctorRole = "doctor"
export const educatorRole = "educator"
export const assistantRole = "assistant"
export const reviewerRole = "reviewer"
